<template>
    <div class="comment-tab-wrap">
        <div class="comment-tab">
            <button @click="currentTab=1" :class="{ 'selectedTab' : currentTab == 1}" class="tab-btn">  
                Comments (74)
            </button>
            <button @click="currentTab=2" :class="{ 'selectedTab' : currentTab == 2}" class="tab-btn">  
                SHOUTOUTS (134)
            </button>
        </div>

        <div class="comment-tab-details">
            <div v-if="currentTab == 1" class="single-details-comments">
                <post-details-comment></post-details-comment>
            </div>
            <div v-if="currentTab == 2" class="single-details-comments">
                 <shoutouts-comment></shoutouts-comment>
            </div>
        </div>
    </div>
</template>


<script>

	export default {
      	name: "post-comments",

		data(){
			return {
		  		currentTab: 1,
	      	}
	    },


	    methods: {
	    	previous() {

	    	},



	    },

	    created() {

	    }

    }

</script>
